import GetPrivateData from './GetPrivateData.js';
import randomBase64 from '../Functions/randomBase64.js';
import buildNumber from '../Functions/buildNumber.js';
import objectToUrlQuery from '../Functions/objectToUrlQuery.js';

/** @namespace config */

export default class Log
{
	constructor()
	{
		const privateData =
		{
			usr_id: ''+config.feed['cacheCode']+('000000'+(Math.random()*10**6|0)).slice(-6),
			inv: false,
			play: false
		};

		getPrivateData.for(this,privateData);

		if(config.feed.playOnVisible)
		{
			config.ac_id.pov = true;
		}
		else if(config.feed.autoplay)
		{
			config.ac_id.autoplay = true;
		}
		else
		{
			config.ac_id.clickToPlay = true;
		}

		postLog.call(this,'GET');
	}

	INV()
	{
		const privateData = getPrivateData.for(this);
		if(privateData.inv)
		{
			return;
		}
		privateData.inv = true;
		postLog.call(this,'INV');
	}

	PLAY()
	{
		const privateData = getPrivateData.for(this);
		if(privateData.play)
		{
			return;
		}
		privateData.play = true;

		this.INV();
		postLog.call(this,'PLAY');
	}

	RTP()
	{
		postLog.call(this,'RTP');
	}

	CLOSE(reason)
	{
		postLog.call(this,'CLOSE'+reason);
	}

	ENGAGEMENT(custom,beacon)
	{
		postLog.call(this,'ENGAGEMENT',custom,beacon);
	}

	reset()
	{
		const privateData = getPrivateData.for(this);
		privateData.inv = false;
		privateData.play = false;
	}
}

const getPrivateData = new GetPrivateData(Log);

const sessionKey = sessionStorage.s2nKey = sessionStorage.s2nKey || randomBase64();

function postLog(cmd,custom,beacon)
{
	const privateData = getPrivateData.for(this);
	const item = config.player.currentItem;

	config.ac_id.pushState();
	config.ac_id.setCmd(cmd);
	const ac_id = ''+config.ac_id;
	config.ac_id.popState();

	const logParameters = Object.assign
	(
		{
			CMD: cmd,
			ESG_key: config.key,
			ES_key: config.key,
			ES_ID: config.feed['ES_ID'] || 0,
			S_RKEY:item['S_RKEY'] || 0,
			USR_ID: privateData.usr_id,
			ST_usrKey: sessionKey,
			SM_ID: item['SM_ID'] || 0,
			C_ID: config.feed['C_ID'],
			C_companyName: config.feed['C_companyName'] || '',
			version: buildNumber(),
			sC_ID: item['C_ID'] || 0,
			AC_ID: ac_id,
			TYPE: config.feed.playerType,
			EXTREF: config.smartMatchLocation,
			REF: config.href,
			PLAYERWIDTH: config.player.element.clientWidth,
			PLAYERCODE: config.playerStatus.logCode,
			OGSET: config.ogSet ? '1' : '0',
			REFONLY: config.smartMatchLocationIsReferrer ? '1' : '0',
			STRIPQUERY: ((config.feed['ESG_stripQueryString'] || 'YES') === 'YES') ? '1' : '0'
		},
		custom || {}
	);

	const logUrl = `${config.logLocation}?${objectToUrlQuery(logParameters)}`;

	if(beacon && navigator.sendBeacon)
	{
		navigator.sendBeacon(logUrl);
	}
	else
	{
		fetch(logUrl).catch(()=>{})
	}
}
